import './styles/index.scss';
import { initSentry } from './common/sentry';
import { addUrlRelaxedValidationMethod } from './utils/custom-validations';
import(/* webpackPreload: true */ './styles/fonts.critical.scss');

export const bootstrap = () => {
  initSentry();
  addUrlRelaxedValidationMethod();
};
